/* Six Images Masonry carousel */
import 'slick-carousel';

export function six_images_masonry() {

    ( ( $ ) => {

		if ( $( '.block--six-images-masonry--sm--images' ).length <= 0 ) {
			return;
		}

        $( '.block--six-images-masonry--sm--images' ).slick( {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            // rows: 0,
            responsive: [ {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    dots: true,
                    slidesToShow: 1,
                }
            } ]
        } );
    } )( window.jQuery );

}
